import React, { useEffect, useState } from 'react';
import {
  ButtonLink,
  ButtonLinkWrapper,
  Line,
  MainButtonsWrapper,
  MainLine,
  MainMenuButton,
  MenuButton,
  MenuContainer,
} from './styles';
import { navigationMenu } from '../../../../../constatnts/navigation';
import { Popover } from 'antd';
import Icon from '../../../../assets/icons';
import { Link } from 'react-router-dom';

const MobileMenu = () => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    const body = document.body;
    if (!collapsed) {
      body.style.overflowY = 'auto';
    } else {
      body.style.overflow = 'hidden';
    }
  }, [collapsed]);

  const content = (
    <MenuContainer>
      <MainButtonsWrapper>
        <ButtonLinkWrapper>
          <ButtonLink href='https://timer.usnexpert.com/' target='_blank'>
            TIMER
          </ButtonLink>
        </ButtonLinkWrapper>
        <MainLine />
        <ButtonLinkWrapper>
          <ButtonLink href='/'>BANK OF CASES</ButtonLink>
        </ButtonLinkWrapper>
      </MainButtonsWrapper>
      {navigationMenu.map((item, index) => (
        <div key={`${index}_${item.title}`}>
          <MainMenuButton>
            <Link to={item.href} onClick={toggleCollapsed}>
              {item.title}
            </Link>
          </MainMenuButton>
          {index !== navigationMenu.length - 1 && <Line />}
        </div>
      ))}
      <MainButtonsWrapper>
        <ButtonLinkWrapper>
          <ButtonLink href='/tournaments'>OUR TOURNAMENTS</ButtonLink>
        </ButtonLinkWrapper>
        <MainLine />
        <ButtonLinkWrapper>
          <ButtonLink href='/'>COURSES</ButtonLink>
        </ButtonLinkWrapper>
        <MainLine />
        <ButtonLinkWrapper>
          <ButtonLink href='/'>TRAININGS</ButtonLink>
        </ButtonLinkWrapper>
      </MainButtonsWrapper>
    </MenuContainer>
  );

  return (
    <Popover
      arrow={false}
      content={content}
      trigger='click'
      open={collapsed}
      placement='bottomLeft'
      styles={{ body: { padding: 0, borderRadius: 0, marginTop: '16px' } }}
      getPopupContainer={() => document.getElementById('main') as HTMLElement}
    >
      <MenuButton onClick={toggleCollapsed}>
        {collapsed ? <Icon variant='close' /> : <Icon variant='menu' />}
      </MenuButton>
    </Popover>
  );
};

export default MobileMenu;
